export default __webpack_public_path__ + "static/media/blog_inner_content_22.ae16ff7f.png";